"use client";

import { Session } from "next-auth";
import { ReactNode } from "react";
import { SessionProvider } from "next-auth/react";
import { tokenRepository } from "@/modules/authentication/repositories/token-repository";
import { getSessionToken } from "@/modules/authentication/hooks/session-token";

export const AuthSessionProvider = ({
    session,
    children,
}: {
    session: Session | undefined;
    children: ReactNode;
}) => {
    // Store a token on client side for passing it to the client
    tokenRepository.write(getSessionToken(session));
    return <SessionProvider session={session}>{children}</SessionProvider>;
};
